<script lang="ts">
import {Vue, Component} from 'vue-facing-decorator';
import NavBar from "@/component/common/NavBar.vue";
import CompetenceComponent from "@/component/project/CompetenceComponent.vue";

@Component({
  components: {CompetenceComponent, NavBar}
})
export default class CompetanceView extends Vue {

}
</script>

<template>
  <NavBar/>
  <div class="view-container">
    <competence-component/>
  </div>
</template>

<style scoped>
.view-container {
  margin-left: 80px;
  height: 100vh;
  background-color: var(--background-color);
  overflow-y: auto;
}
</style>